import { FormEvent, useState } from 'react';
import { requestMagicLink } from '../lib/auth';

export function Login() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    setErrorMsg(null);
    try {
      await requestMagicLink(email);
      setStatus('sent');
    } catch (err) {
      setStatus('error');
      setErrorMsg(err instanceof Error ? err.message : 'Unknown error');
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>Eisenhower Matrix</h1>
        <p className="login-sub">Sign in with a magic link.</p>

        {status === 'sent' ? (
          <div className="login-sent">
            <p>Check <strong>{email}</strong> for a sign-in link.</p>
            <button type="button" onClick={() => { setStatus('idle'); setEmail(''); }}>
              Use a different email
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              disabled={status === 'sending'}
            />
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send link'}
            </button>
            {errorMsg && <p className="err">{errorMsg}</p>}
          </form>
        )}
      </div>
    </div>
  );
}
